import type { FC, ReactNode } from "react";
import React from "react";

import clsx from "clsx";

import { ButtonGroupWrapper } from "./style";

import type { ButtonPropsInterface } from "../Button";
import Button from "../Button";

interface OptType {
	content: ReactNode;
	onClick: () => void;
	id?: string;
}

const ButtonGroup: FC<{ buttonProps: ButtonPropsInterface; vertical?: boolean; optOne: OptType; optTwo: OptType }> = ({
	buttonProps,
	vertical,
	optOne,
	optTwo
}) => {
	return (
		<ButtonGroupWrapper className={clsx(vertical ? "flex flex-col vertical" : "flex flex-row linear")}>
			<Button {...buttonProps} onClick={optOne.onClick}>
				{optOne.content}
			</Button>
			<div className={clsx("bg-white", vertical ? "h-[1px]" : "h-full w-[1px]")} />
			<Button {...buttonProps} onClick={optTwo.onClick}>
				{optTwo.content}
			</Button>
		</ButtonGroupWrapper>
	);
};

export default ButtonGroup;
